import gql from 'graphql-tag';

export const UPDATE_ORGANIZATION_CANCELATION_MUTATION = gql`
  mutation updateOrganizationCancelation($organization: ID!, $cancelation: cancelationPolicyInput!) {
    updateOrganizationCancelation(_organization: $organization, cancelation: $cancelation) {
      _id
    }
  }
`;

export const UPDATE_REVIEW_MANDATORY_MUTATION = gql`
  mutation updateReviewMandatory($organization: ID!, $mandatory: Boolean!) {
    updateOrganizationReviewMandatory(_organization: $organization, mandatory: $mandatory) {
      _id
    }
  }
`;

export const UPDATE_SURVEY_SKIPPABLE_MUTATION = gql`
  mutation updateSurveySkippable($organization: ID!, $skippable: Boolean!) {
    updateOrganizationSkipSurvey(_organization: $organization, skippable: $skippable) {
      _id
    }
  }
`;

export const UPDATE_SERVICE_FEE_MUTATION = gql`
  mutation updateServiceFee($organization: ID!, $serviceFeeInput: ServiceFeeInput!) {
    updateOrganizationServiceFee(_organization: $organization, serviceFee: $serviceFeeInput) {
      _id
    }
  }
`;

export const UPDATE_COMMISSION_STRUCTURE_MUTATION = gql`
  mutation updateCommissionStructure($organization: ID!, $commissionStructureInput: CommissionStructureInput!) {
    updateOrganizationServiceFee(_organization: $organization, commissionStructure: $commissionStructureInput) {
      _id
    }
  }
`;

export const UPDATE_SUPPORT_MUTATION = gql`
  mutation updateSupport($organization: ID!, $email: String, $tutorEmail: String, $phone: String, $channels: [String]!) {
    updateOrganizationSupport(
      _organization: $organization,
      email: $email,
      tutorEmail: $tutorEmail,
      phone: $phone,
      channels: $channels
    ) {
      _id
    }
  }
`;

export const UPDATE_ORGANIZATION_SPLIT_CHARGE_MUTATION = gql`
  mutation updateOrganizationSplitCharge($organization: ID!, $amount: Int!) {
    updateOrganizationSplitCharge(_organization: $organization, amount: $amount) {
      _id
    }
  }
`;

export const ORGANIZATION_STRIPE_LOGIN_LINK_QUERY = gql`
  query organizationStripeLoginLink($organization: ID!) {
    organizationStripeLoginLink(_organization: $organization)
  }
`;



// WEBPACK FOOTER //
// ./src/modules/organization/api.js